<template>
  <NButton label="Login">
    <template #trailing>
      <NIcon name="i-heroicons-arrow-right-on-rectangle-20-solid" />
    </template>
  </NButton>
</template>
